export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio',
  },
  {
    title: '规格名称',
    field: 'groupSpecName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: '花型',
    field: 'orderGoodsPattern',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: '颜色',
    field: 'orderGoodsColor',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: '面料位置',
    field: 'fabricPositionName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: '面料编号',
    field: 'fabricNo',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: '面料显示名称',
    field: 'fabricDisplayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: '面料克重',
    field: 'fabricWeight',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  // {
  //   title: '客户指定供应商',
  //   field: 'isSpecify',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 120,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  //   slots: {
  //     default: 'isSpecify'
  //   }
  // },
  // {
  //   title: '供应商名称',
  //   field: 'scmName',
  //   headerAlign: 'center',
  //   align: 'left',
  //   minWidth: 280,
  //   showHeaderOverflow: true,
  //   showOverflow: true
  // }
]
